export default __webpack_public_path__ + "static/media/DeleteDisabled.4ce4f0c2.svg";